"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("./..");

var _formalizer = _interopRequireDefault(require("../Form/formalizer"));

var _iso = _interopRequireDefault(require("iso-639-1"));

var LanguageSelect = function LanguageSelect(_ref) {
  var languageCodes = _ref.languageCodes,
      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["languageCodes"]);
  return /*#__PURE__*/_react.default.createElement(_.SelectField, (0, _extends2.default)({}, props, {
    options: languageCodes.map(function (languageCode) {
      return {
        label: _iso.default.getNativeName(languageCode.toLowerCase()),
        value: languageCode
      };
    })
  }));
};

LanguageSelect.propTypes = {
  variant: _propTypes.default.oneOfType([_propTypes.default.oneOf(['fill', 'outline', 'clear']), _propTypes.default.string]),
  languageCodes: _propTypes.default.array
};
LanguageSelect.defaultProps = {
  variant: 'fill',
  languageCodes: ['', 'ES', 'EN', 'PT', 'ZH', 'JA', 'FR', 'IT', 'DE']
};
LanguageSelect.displayName = 'LanguageSelect';

var _default = (0, _formalizer.default)(LanguageSelect);

exports.default = _default;